import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const DownloadSectionLayout = styled.div`
  padding: 128px 0;
  background-color: #f8f8f8;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding: 96px 0;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 96px 0;
  }
`;

export const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: transparent;
  cursor: pointer;
`;

export const DownloadImg = styled.img`
  width: 100%;
  aspect-ratio: 1232/468;

  object-fit: contain;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    aspect-ratio: 960/468;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    aspect-ratio: 361/150;
  }
`;
